import AppDBStorage from '@Services/AppDBStorage';

class TableColumnsSwitcherStorage extends AppDBStorage {
  constructor() {
    super('tableColumnsSwitcher_');
  }
}

export default new TableColumnsSwitcherStorage();
